import { useContext } from 'react'
import { AppDataContext } from '../providers/AppData'

export default function getDistancesForLocale(): string[] {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { tenantSettings } = useContext(AppDataContext)

  return (tenantSettings?.search?.DISTANCES || [])
    .sort((a, b) => a - b)
    .map((distance: number) => (distance === 0 ? 'nolimit' : distance.toString()))
}
